import { getCoreSetupAuditTrailSourceNamePrefixSlice } from './get';

export const { requestGetCoreSetupAuditTrailSourceNamePrefix, resetGetCoreSetupAuditTrailSourceNamePrefix } =
getCoreSetupAuditTrailSourceNamePrefixSlice.asyncActionCreators;
